import { TBillingInterval } from "@/types/app";
import formatCurrency from "@/utils/formatCurrency";
import { PRICE_UNAVAILABLE } from "@/utils/formatPriceOrNA";
import { getBillingLabel } from "@/utils/getBillingLabel";

/** Money with no billing suffix, e.g. `$60` */
export function formatAmount(amount: number, currency: string) {
  return formatCurrency(amount, currency, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

/** Money for the current billing cycle, e.g. `$45/m` — "NA" when unpriced. */
export function formatCyclePrice(
  amount: number | undefined,
  currency: string,
  billingPeriod: TBillingInterval,
) {
  if (amount === undefined) return PRICE_UNAVAILABLE;

  return `${formatAmount(amount, currency)}/${getBillingLabel(billingPeriod)}`;
}
